/**
 *
 * Asynchronously loads the component for TaxpayerTaxReturns
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TaxpayerTaxReturns = lazyLoad(
  () => import('app/modules/Taxpayer/TaxpayerTaxReturns/index'),
  (module) => module.TaxpayerTaxReturns
);
